export default "https://cdn.questicon.mathletics.com/assets/images/fluency-fail-mountain-0d9a72792bc10f75788636afec86fc52.png";